import components from './components'
import computed from './computed'
import data from './data'
import methods from './methods'
import mounted from './mounted'
import props from './props'

export default {
  components,
  computed,
  data,
  methods,
  mounted,
  props,
  resourcePath: '/v1/patient/scheduling/schedules',
  beforeDestroy () {
    this.doCancelReserve()
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/form/resources/index.js